import { loadScriptOnce } from '../index'
import { getWxSignature } from './api'

export class WxSdk {
  constructor() {
    this.jsApiList = [] //当前已经注入权限的jsApiList
    this.readyCallback = null // ready
    this.errorCallback = null // error
  }

  /**
   * 动态加载wx JSSDK
   * @returns Promise
   */
  loadWxJsSdk() {
    return loadScriptOnce(
      'wx',
      'https://res.wx.qq.com/open/js/jweixin-1.4.0.js'
    )
  }

  /**
   *
   * @param {string} param0 url
   * @param {string} param1 cityId
   */
  getWxSign({ url, cityId }) {
    const url2 = url.includes('#') ? url.split('#')[0] : url
    return getWxSignature({
      url: url2,
      cityId
    })
  }

  /**
   * 通过config接口注入权限验证配置
   */
  wxConfig({ appId, timeStamp, nonceStr, signature, jsApiList }) {
    this.jsApiList = jsApiList
    this.loadWxJsSdk().then(wx => {
      wx.config({
        debug: false,
        appId,
        timestamp: timeStamp,
        nonceStr,
        signature,
        jsApiList
      })
    })
  }

  /**
   * 注册ready回调，用于wx.ready
   * 必须在wxConfig之前注册
   * @param {function} func
   */
  installReadyCallback(func) {
    if (typeof func === 'function') {
      this.readyCallback = func
      this.loadWxJsSdk().then(wx => {
        wx.ready(() => {
          this.readyCallback && this.readyCallback(wx)
        })
      })
    } else {
      console.error('installReadyCallback参数错误')
    }
  }

  /**
   * 注册error回调，用于wx.error
   * 必须在wxConfig之前注册
   * @param {function} func
   */
  installErrorCallback(func) {
    if (typeof func === 'function') {
      this.errorCallback = func
      this.loadWxJsSdk().then(wx => {
        wx.error(err => {
          this.errorCallback && this.errorCallback(err)
        })
      })
    } else {
      console.error('installErrorCallback参数错误')
    }
  }

  /**
   * 判断当前客户端版本是否支持指定JS接口
   * 检测多个接口时，全对，resolve，否则reject
   * @param {Array} apis
   * @returns Promise
   */
  checkJsApi(apis) {
    if (!Array.isArray(apis)) {
      console.error('checkJsApi参数错误')
      return Promise.reject()
    }
    return new Promise((resolve, reject) => {
      this.loadWxJsSdk()
        .then(wx => {
          wx.checkJsApi({
            jsApiList: apis,
            success: res => {
              const { checkResult } = res || {}
              Object.keys(checkResult || {}).forEach(key => {
                if (!checkResult[key]) {
                  console.error(`checkJsApi: ${checkResult[key]}不支持`)
                  reject()
                  return
                }
              })
              resolve(wx)
            }
          })
        })
        .catch(reject)
    })
  }

  /**
   * 获取当前已经注入权限的jsApiList
   * @returns Array
   */
  getJsApiList() {
    return this.jsApiList
  }
}
